<div class="mb-3">

  <label *ngIf="label" class="form-label d-block">{{ label }}</label>

  <div [class]="inline ? 'd-flex flex-wrap gap-3' : ''">
    <div
      *ngFor="let opt of options; trackBy: trackByValue"
      class="form-check"
      [class.form-check-inline]="inline">

      <input
        class="form-check-input"
        [class.is-invalid]="hasError"
        type="radio"
        [id]="groupName + '_' + opt.value"
        [name]="groupName"
        [checked]="isChecked(opt.value)"
        [disabled]="isDisabled || !!opt.disabled"
        (change)="handleChange(opt.value)"
      />

      <label class="form-check-label" [for]="groupName + '_' + opt.value">
        {{ opt.label }}
      </label>

    </div>
  </div>

  <is-form-error *ngIf="control" [control]="control"></is-form-error>

</div>
